var h = Object.defineProperty;
var o = (r, l, e) => l in r ? h(r, l, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[l] = e;
var i = (r, l, e) => (o(r, typeof l != "symbol" ? l + "" : l, e), e);
import { fabric as c } from "fabric";
const s = {
  idle: {
    default: {
      selectable: !1,
      radius: 4.5,
      originX: "center",
      originY: "center",
      strokeWidth: 0
    },
    light: {
      fill: "#49565D"
    },
    dark: {
      fill: "white"
    }
  },
  dragStart: {
    default: {
      radius: 3.25
    },
    light: {
      fill: "#49565D"
    },
    dark: {
      fill: "white"
    }
  },
  select: {
    default: {
      radius: 2.5
    },
    light: {
      fill: "white"
    },
    dark: {
      fill: "#5E63E5",
      stroke: "black",
      strokeWidth: -1
    }
  },
  selectedPOI: {
    default: {
      radius: 3.5
    },
    light: {
      fill: "white",
      stroke: "#49565D",
      strokeWidth: 3
    },
    dark: {
      fill: "#49565D",
      stroke: "white",
      strokeWidth: 3
    }
  }
}, d = {
  idle: {
    default: {
      selectable: !1,
      radius: 6.5,
      originX: "center",
      originY: "center",
      strokeWidth: 0
    },
    light: {
      fill: "white"
    },
    dark: {
      fill: "#D0D0D0"
    }
  },
  dragStart: {
    default: {
      fill: "",
      strokeWidth: -5
    },
    light: {
      stroke: "#49565D"
    },
    dark: {
      stroke: "white"
    }
  },
  select: {
    default: {
      radius: 6.5
    },
    light: {
      fill: "#49565D"
    },
    dark: {
      fill: "white"
    }
  },
  selectedPOI: {
    default: {
      radius: 9
    },
    light: {
      fill: "#797DF6DD"
    },
    dark: {
      fill: "#797DF6DD"
    }
  }
}, a = {
  idle: {
    default: {
      selectable: !1,
      visible: !1,
      radius: 7,
      originX: "center",
      originY: "center"
    },
    light: {},
    dark: {}
  },
  dragStart: {
    default: {
      visible: !0,
      strokeWidth: 6,
      fill: ""
    },
    light: { stroke: "#5E63E566" },
    dark: { stroke: "#5E63E599" }
  },
  select: {
    default: {
      visible: !0,
      strokeWidth: 6,
      fill: ""
    },
    light: { stroke: "#5E63E566" },
    dark: { stroke: "#5E63E599" }
  },
  selectedPOI: {
    default: {
      visible: !0,
      radius: 10.5,
      strokeWidth: 1.5,
      fill: "#FFFFFFCC"
    },
    light: {
      stroke: "#797DF6"
    },
    dark: { stroke: "#797DF6" }
  }
};
class y extends c.Group {
  constructor(e) {
    e = {
      ...e,
      selectable: !1,
      originX: "center",
      originY: "center"
    };
    const t = new c.Circle({
      ...s.idle.default,
      ...s.idle[e.styleType]
    }), u = new c.Circle({
      ...d.idle.default,
      ...d.idle[e.styleType]
    }), f = new c.Circle({
      ...a.idle.default,
      ...a.idle[e.styleType]
    });
    super([f, u, t], e);
    i(this, "objType");
    i(this, "innerCircle");
    i(this, "outerCircle");
    i(this, "outerStatusCircle");
    i(this, "styleType");
    i(this, "updateStyle", (e, t = "idle") => {
      this.styleType = e, this.outerStatusCircle.set({
        ...a.idle.default,
        ...a.idle[this.styleType],
        ...a[t].default,
        ...a[t][this.styleType]
      }), this.outerCircle.set({
        ...d.idle.default,
        ...d.idle[this.styleType],
        ...d[t].default,
        ...d[t][this.styleType]
      }), this.innerCircle.set({
        ...s.idle.default,
        ...s.idle[this.styleType],
        ...s[t].default,
        ...s[t][this.styleType]
      });
    });
    this.objType = "SourcePoint", this.styleType = e.styleType, this.innerCircle = t, this.outerCircle = u, this.outerStatusCircle = f;
  }
}
export {
  y as SourcePoint,
  s as innerCircleStyles,
  d as outerCircleStyles,
  a as outerStatusCircleStyles
};
//# sourceMappingURL=index.es251.js.map
